<template>
  <v-card class="creation-right-panel-container">
    <v-expansion-panels
      v-model="moduleOpened"
      accordion
      multiple
      class="d-flex fill-height align-content-start align-stretch overflow-y-hidden"
    >
      <!-- LAYER PANEL -->
      <v-expansion-panel>
        <v-expansion-panel-header>{{ $t("creation.right-panel.layers") }}</v-expansion-panel-header>
        <v-expansion-panel-content
          class="overflow-y-auto"
          :style="panelHeight"
        >
          <layer-module
            v-if="layers.length > 0"
            :layers.sync="getLayers"
            :layer-selected="getLayerSelected"
            :creation-access="creationAccess"
            @select-layer="selectLayer"
            @layers-moved="layersMoved"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- EXTRA OPTIONS PANEL -->
      <v-expansion-panel>
        <v-expansion-panel-header>{{ $t("creation.right-panel.extra-options") }}</v-expansion-panel-header>
        <v-expansion-panel-content
          class="overflow-y-auto"
          :style="panelHeight"
        >
          <options-module :element-current="element" />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- ANIMATIONS IN PANEL -->
      <v-expansion-panel>
        <v-expansion-panel-header>{{ $t("creation.right-panel.animationIn") }}</v-expansion-panel-header>
        <v-expansion-panel-content
          class="overflow-y-auto"
          :style="panelHeight"
        >
          <anim-module
            :element-current="element"
            role="IN"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- ANIMATIONS OUT PANEL -->
      <v-expansion-panel>
        <v-expansion-panel-header>{{ $t("creation.right-panel.animationOut") }}</v-expansion-panel-header>
        <v-expansion-panel-content
          class="overflow-y-auto"
          :style="panelHeight"
        >
          <anim-module
            :element-current="element"
            role="OUT"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!-- TEMPLATE PANEL -->
      <v-expansion-panel>
        <v-expansion-panel-header>{{ $t("creation.right-panel.template") }}</v-expansion-panel-header>
        <v-expansion-panel-content
          class="overflow-y-auto"
          :style="panelHeight"
        >
          <template-module
            :element-current="element"
            :template-access="templateAccess"
            @edit-changed="editChanged"
            @move-changed="moveChanged"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
// Components
import layerModule from "./RightPanel/LayerModule";
import optionsModule from "./RightPanel/OptionsModule";
import animModule from "./RightPanel/AnimationModule";
import templateModule from "./RightPanel/TemplateModule";

export default {
  components: {
    layerModule,
    optionsModule,
    animModule,
    templateModule,
  },
  props: {
    element: {
      type: Object,
      default: () => {},
    },
    layers: {
      type: Array,
      default: () => [],
    },
    layerSelected: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      creationAccess: false,
      moduleOpened: [0, 1, 2],
      numberOfPanel: 3,
      sizeOfModuleTitleClosed: 48, // VALUE FROM VUETIFY
      sizeOfModuleTitleOpened: 64, // VALUE FROM VUETIFY
      templateAccess: false,
      tempLayers: [],
    };
  },
  computed: {
    getLayers: {
      get() {
        return this.layers;
      },
      set(value) {
        this.tempLayers = value;
        this.$emit("update:layers", value);
      },
    },
    getLayerSelected() {
      return this.layerSelected;
    },
    nbPanelClose() {
      return 3 - this.moduleOpened.length;
    },
    nbPanelOpen() {
      return this.moduleOpened.length;
    },
    panelHeight() {
      const headerHeight = 80;
      const footerHeight = 80;

      let totalHeight = headerHeight + footerHeight;
      totalHeight = totalHeight + this.nbPanelClose * this.sizeOfModuleTitleClosed;
      totalHeight = totalHeight + this.nbPanelOpen * this.sizeOfModuleTitleOpened;

      if (this.nbPanelOpen > 0) {
        totalHeight = totalHeight / this.nbPanelOpen;
      }

      return "max-height: calc(100vh / " + this.nbPanelOpen + " - " + totalHeight + "px);";
    },
  },
  watch: {
    moduleOpened: function (val) {
      const saveModule = JSON.stringify(val);
      localStorage.creationPanel = saveModule;
    },
  },
  mounted() {
    this.creationAccess = this.$store.state.user.permissions.includes("1|");
    this.templateAccess = this.$store.state.user.permissions.includes("|2|");
    this.tempLayers = this.layers;
    this.restorePanel();
  },
  methods: {
    editChanged(value) {
      this.$emit("edit-changed", value);
    },
    layersMoved(value) {
      this.$emit("layers-moved", value);
    },
    moveChanged(value) {
      this.$emit("move-changed", value);
    },
    restorePanel() {
      const saveModule = localStorage.creationPanel;
      if (saveModule !== undefined) {
        this.moduleOpened = JSON.parse(saveModule);
      }
    },
    selectLayer(value) {
      this.$emit("select-layer", value);
    },
  },
};
</script>

<style>
.creation-right-panel-container {
  height: 75vh;
}
</style>
